import { months_map } from "@/constants";

const twelveMonths = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

export function sortPeriods(m1: string, m2: string) {
  return months_map[m1 as keyof typeof months_map]- months_map[m2 as keyof typeof months_map]
}

// Конвертировать список кодов месяцев в массив индексов
const getMonthIndexesList = (periods: string[]): number[] => {
  return periods.map((month): number => twelveMonths.indexOf(month) + 1);
}

// Преобразование массива кодов(англоязычных названий) периодов в массив уникальных кодов месяцев
export const convertPeriodsListToMonthArray = (periods: string[]): string[] => {
  let months: string[] = [];
  for(let month of periods) {
    if (month === "january") months.push("january");
    if (month === "february") months.push("february");
    if (month === "march") months.push("march");
    if (month === "april") months.push("april");
    if (month === "may") months.push("may");
    if (month === "june") months.push("june");
    if (month === "july") months.push("july");
    if (month === "august") months.push("august");
    if (month === "september") months.push("september");
    if (month === "october") months.push("october");
    if (month === "november") months.push("november");
    if (month === "december") months.push("december");
    if (month === "year") return twelveMonths;;
    if (month === "a_month") months.push("january");
    if (month === "two_months") months = [...months, "january", "february"];
    if (month === "three_months") months = [...months, "january", "february", "march"];
    if (month === "four_months") months = [...months, "january", "february", "march", "april"];
    if (month === "five_months") months = [...months, "january", "february", "march", "april", "may"];
    if (month === "six_months") months = [...months, "january", "february", "march", "april", "may", "june"];
    if (month === "seven_months") months = [...months, "january", "february", "march", "april", "may", "june", "july"];
    if (month === "eight_months") months = [...months, "january", "february", "march", "april", "may", "june", "july", "august"];
    if (month === "nine_months") months = [...months, "january", "february", "march", "april", "may", "june", "july", "august", "september"];
    if (month === "ten_months") months = [...months, "january", "february", "march", "april", "may", "june", "july", "august", "september", "october"];
    if (month === "eleven_months") months = [...months, "january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november"];
    if (month === "twelve_months") return twelveMonths;
    if (month === "first_quarter") months = [...months, "january", "february", "march"];
    if (month === "second_quarter") months = [...months, "april", "may", "june"];
    if (month === "third_quarter") months = [...months, "july", "august", "september"];
    if (month === "thourth_quarter") months = [...months, "october", "november", "december"];
    if (month === "first_half") months = [...months, "january", "february", "march", "april", "may", "june"];
    if (month === "second_half") months = [...months, "july", "august", "september", "october", "november", "december"];
    if (month === "wane_a_month") months.push("december");
    if (month === "wane_two_months") months = [...months, "december", "november"];
    if (month === "wane_three_months") months = [...months, "december", "november", "october"];
    if (month === "wane_four_months") months = [...months, "december", "november", "october", "september"];
    if (month === "wane_five_months") months = [...months, "december", "november", "october", "september", "august"];
    if (month === "wane_six_months") months = [...months, "december", "november", "october", "september", "august", "july"];
    if (month === "wane_seven_months") months = [...months, "december", "november", "october", "september", "august", "july", "june"];
    if (month === "wane_eight_months") months = [...months, "december", "november", "october", "september", "august", "july", "june", "may"];
    if (month === "wane_nine_months") months = [...months, "december", "november", "october", "september", "august", "july", "june", "may", "april"];
    if (month === "wane_ten_months") months = [...months, "december", "november", "october", "september", "august", "july", "june", "may", "april", "march"];
    if (month === "wane_eleven_months") months = [...months, "december", "november", "october", "september", "august", "july", "june", "may", "april", "march", "february"];
    if (month === "wane_twelve_months") return twelveMonths;
  }
  return [...new Set(months)].sort(sortPeriods);
}
